import { colord as e } from "colord";
//#region src/common/normalize-to-hex.ts
var t = (t) => t.startsWith("#") ? t : e(t).toHex();
//#endregion
export { t as normalizeToHex };
